export default __webpack_public_path__ + "static/media/replyFaq.0439ea9f.svg";